module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter"
  }, [_c('span', {
    staticClass: "filter__text"
  }, [_vm._v("\n        " + _vm._s(_vm.i18n.showProjects) + ":\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "filter__wrap"
  }, [(_vm.all) ? _c('span', {
    staticClass: "filter__trigger",
    on: {
      "click": _vm.toggleListFilter
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n.all) + "\n        ")]) : _c('span', {
    staticClass: "filter__trigger",
    on: {
      "click": _vm.toggleListFilter
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n.filter) + ": " + _vm._s(_vm.yearsActiveToString) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "filter__list-wrap"
  }, [_c('ul', {
    staticClass: "filter__list",
    class: {
      'filter__list--xs-visible': _vm.filterXsVisible
    }
  }, [_vm._l((_vm.yearsFiltered), function(year) {
    return _c('li', {
      staticClass: "filter__item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (year.active),
        expression: "year.active"
      }],
      staticClass: "filter__input",
      attrs: {
        "type": "checkbox",
        "name": year.year,
        "id": year.year
      },
      domProps: {
        "checked": Array.isArray(year.active) ? _vm._i(year.active, null) > -1 : (year.active)
      },
      on: {
        "change": _vm.triggerRouteChange,
        "__c": function($event) {
          var $$a = year.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (year.active = $$a.concat($$v))
            } else {
              $$i > -1 && (year.active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            year.active = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "filter__label",
      attrs: {
        "for": year.year
      }
    }, [_vm._v("\n                        " + _vm._s(year.year) + " " + _vm._s(_vm.i18n.year) + "\n                    ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "filter__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.all),
      expression: "all"
    }],
    staticClass: "filter__input",
    attrs: {
      "type": "checkbox",
      "name": "all",
      "id": "all",
      "disabled": _vm.all
    },
    domProps: {
      "checked": Array.isArray(_vm.all) ? _vm._i(_vm.all, null) > -1 : (_vm.all)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.all,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.all = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.all = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.all = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "filter__label",
    attrs: {
      "for": "all"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.i18n.showAll) + "\n                    ")])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d8d37c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/modules/list-filter.vue
// module id = 355
// module chunks = 0